module.exports = __webpack_public_path__ + "ca2a59cb/img/google.68f3823e.svg";